// extracted by mini-css-extract-plugin
export var bubble = "_1v-0";
export var container = "_1v-f";
export var contrastBorder = "_1v-g";
export var greyOut = "_1v-2";
export var initialsColor0 = "_1v-3";
export var initialsColor1 = "_1v-4";
export var initialsColor10 = "_1v-d";
export var initialsColor11 = "_1v-e";
export var initialsColor2 = "_1v-5";
export var initialsColor3 = "_1v-6";
export var initialsColor4 = "_1v-7";
export var initialsColor5 = "_1v-8";
export var initialsColor6 = "_1v-9";
export var initialsColor7 = "_1v-a";
export var initialsColor8 = "_1v-b";
export var initialsColor9 = "_1v-c";
export var initialsWrapper = "_1v-1";
export var large = "_1v-l";
export var medium = "_1v-k";
export var mediumSmall = "_1v-j";
export var mediumSmallMedium = "_1v-o";
export var micro = "_1v-h";
export var small = "_1v-i";
export var tiny = "_1v-n";
export var xTiny = "_1v-m";